export default __webpack_public_path__ + "static/restau_image-27c86febf96f72b870e917a43a59ee1f.jpg";